var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('nav-menu', _vm._g(_vm._b({
    attrs: {
      "name": "Invitations / RSVPs",
      "title": "Send any card as an invitation",
      "subtitle": "Customize and track RSVPs automatically",
      "action": "View invitations",
      "icon": _vm.mdiCards,
      "to": {
        name: 'catalog',
        query: {
          q: 'Invitation',
          type: 'INVITATION'
        }
      }
    }
  }, 'nav-menu', _vm.$attrs, false), _vm.$listeners), [_c('div', {
    staticClass: "pa-3 d-flex flex-column-reverse d-sm-block"
  }, [_c('div', {
    staticClass: "mt-3 mt-sm-0 float-sm-right",
    style: {
      width: _vm.$vuetify.breakpoint.xsOnly ? '100%' : '320px'
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-responsive', {
    attrs: {
      "aspect-ratio": 16 / 9
    }
  }, [_c('video', {
    staticClass: "d-block",
    attrs: {
      "width": "100%",
      "playsinline": "",
      "autoplay": "autoplay",
      "muted": "muted",
      "loop": "loop",
      "src": "https://cdn.ellacard.com/nav/invitations_320x180.mp4"
    },
    domProps: {
      "muted": true
    }
  })])], 1), _c('div', {
    staticClass: "mt-2 caption"
  }, [_vm._v("Build RSVP forms with custom questions and automatically collect responses from recipients")])], 1), _c('div', [_c('div', {
    staticClass: "caption"
  }, [_vm._v("Invitations for any occasion")]), _vm._l([['Party', _vm.mdiBalloon], ['Holiday', _vm.mdiPineTree], ['Baby Shower', _vm.mdiBabyCarriage], ['Retirement', _vm.mdiBriefcaseCheck], ['Save the Date', _vm.mdiCalendarHeart]], function (_ref) {
    var q = _ref[0],
        icon = _ref[1];
    return _c('div', {
      staticClass: "mx-n2"
    }, [_c('v-btn', {
      attrs: {
        "text": "",
        "color": "primary",
        "to": {
          name: 'catalog',
          query: {
            q: ['Invitation', q],
            type: 'INVITATION'
          }
        }
      }
    }, [_c('v-icon', {
      staticClass: "mr-1",
      attrs: {
        "small": ""
      },
      domProps: {
        "innerHTML": _vm._s(icon)
      }
    }), _vm._v(_vm._s(q) + " ")], 1)], 1);
  }), _c('div', {
    staticClass: "mx-n2"
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary",
      "to": {
        name: 'catalog',
        query: {
          q: ['Invitation', 'Template', 'blank'],
          type: 'INVITATION'
        }
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiPencilBoxOutline)
    }
  }), _vm._v("Design your own… ")], 1)], 1)], 2)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }